/* Esencias del Cielo · añadir al carrito desde la home sin salir de la página */
(function () {
  if (window.__edcHomeCart) return;
  window.__edcHomeCart = true;

  function refreshCart(variantId, productId) {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        try {
          var ev = new Event('cart:update', { bubbles: true });
          ev.detail = { resource: cart, sourceId: 'edc-home', data: { source: 'edc-home', itemCount: cart.item_count, variantId: String(variantId), productId: String(productId || '') } };
          document.dispatchEvent(ev);
        } catch (e) {}
        try {
          var drawer = document.querySelector('cart-drawer-component');
          if (drawer && typeof drawer.open === 'function') drawer.open();
        } catch (e) {}
        return cart;
      });
  }

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.matches || !input.matches('[data-edc-chip]')) return;
    var form = document.getElementById(input.getAttribute('form'));
    if (!form) return;
    form.querySelector('input[name="id"]').value = input.value;
    var btn = form.querySelector('button');
    btn.disabled = false;
    btn.textContent = btn.getAttribute('data-ready') || 'Añadir al carrito';
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[data-edc-add]')) return;
    var idInput = form.querySelector('input[name="id"]');
    if (!idInput || !idInput.value) { e.preventDefault(); return; }
    e.preventDefault();
    var btn = form.querySelector('button');
    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Añadiendo…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j && (res.j.description || res.j.message) || 'Error');
        btn.classList.add('is-added');
        btn.textContent = 'Añadido ✓';
        return refreshCart(idInput.value, form.getAttribute('data-product-id'));
      })
      .then(function () {
        setTimeout(function () { btn.classList.remove('is-added'); btn.textContent = original; btn.disabled = false; }, 2200);
      })
      .catch(function (err) {
        btn.textContent = 'Sin stock suficiente';
        setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 2600);
      });
  });
})();
